const projectsData = [
    {
      imgPath: require("../../Assets/Certificates/ContentWritingCert.jpg"),
      title: "Salty Sardonics Content Writing Internship Certificate",
      description: "",
      ghLink: "https://www.linkedin.com/in/ali-hassan-mughal/"
    },
    {
      imgPath: require("../../Assets/Certificates/CloudCompCert_page-0001.jpg"),
      title: "Cloud Computing Certificate by Learn Quest",
      description: "",
      ghLink: "https://www.linkedin.com/in/ali-hassan-mughal/"
    },
    {
      imgPath: require("../../Assets/Certificates/WebDevelopmentCertificate_page-0001.jpg"),
      title: "Web Development Certificate by IBM",
      description: "",
      ghLink: "https://www.linkedin.com/in/ali-hassan-mughal/"
    },
    {
      imgPath: require("../../Assets/Certificates/ABDA_cert.jpg"),
      title: "Big Data Analytics Certificate by Grrifith University",
      description: "",
    },
    {
      imgPath: require("../../Assets/Certificates/PUG_Hack.jpg"),
      title: "Pakistan User Group Hackathon on Power Apps",
      description: "",
    },
    {
      imgPath: require("../../Assets/Certificates/Astera_Bootcamp.jpg"),
      title: "Astera Data Integration Bootcamp",
      description: "",
    }
  ];
  
  export default projectsData;
  